<template>
    <v-card class="core_card" variant="flate" style="height: 100%;overflow-y: auto !important;">
        <v-row>
            <v-col cols="12">
                <div class="d-flex ga-2 align-center">
                    <h2 class="card_title">WareHouse Contacts</h2>
                    <!-- <v-tooltip v-if="role < 6" text="Add New Warehouse" location="bottom">
                        <template #activator="{ props }">
                            <span 
                                v-bind="props"
                                @click="formDialog('Warehouse')" 
                                class="mdi mdi-plus-circle "
                                style="font-size: 20px;color: #082FB1;cursor: pointer;"
                            ></span>
                        </template>
                    </v-tooltip> -->
                </div>
            </v-col>
            <v-col cols="5" class="pb-0">
                <AutoComplete 
                    placeholder="Select WareHouse"
                    v-model="selectedUser"
                    item-value="id"
                    item-title="warehouse_name"
                    :items="warehouse"
                    return-object
                    @update:model-value="onSelectWarehouse"
                />
            </v-col>

             <v-col cols="5" class="pb-0 mt-2">
                <v-icon color="black" @click="reloadPage">mdi-refresh</v-icon>
            </v-col>
        </v-row>

        <!-- <template  v-if="selectedName"> -->
            <!-- <v-row class="mb-10"> -->
                <!-- <v-col cols="12" class="pa-1">
                    <div class="d-flex"> 
                        <v-col cols="10">
                            <h2 class="sub_title">{{selectedName}}</h2>
                        </v-col>
                        <v-col cols="2" class="d-flex ga-4 justify-end">
                            <v-tooltip v-if="role < 6" text="Edit Warehouse" location="bottom">
                                <template #activator="{ props }">
                                    <span 
                                        v-bind="props" 
                                        @click="editWareHouse(value,WHindex)" 
                                        class="mdi mdi-pencil "
                                        style="font-size: 20px;color: #082FB1;cursor: pointer;"
                                    ></span>
                                </template>
                            </v-tooltip>
                            <v-tooltip v-if="role < 6" text="EDI Transcations" location="bottom">
                                <template #activator="{ props }">
                                    <span 
                                        v-bind="props" 
                                        @click="ediChips(value)" 
                                        class="mdi mdi-information-outline "
                                        style="font-size: 20px;color: #082FB1;cursor: pointer;"
                                    ></span>
                                </template>
                            </v-tooltip>
                            <v-tooltip v-if="role < 6" text="Add Warehouse Users" location="bottom">
                                <template #activator="{ props }">
                                    <span 
                                        v-bind="props" 
                                        @click="formDialog(value.warehouse_name, WHindex)" 
                                        class="mdi mdi-plus-circle "
                                        style="font-size: 20px;color: #082FB1;cursor: pointer;"
                                    ></span>
                                </template>
                            </v-tooltip>
                            
                            <v-tooltip v-if="role < 6" text="Copy Users Mail" location="bottom">
                                <template #activator="{ props }">
                                    <span 
                                        v-bind="props"
                                        @click="copyAllEmails(value.users)" 
                                        class="mdi mdi-content-copy"
                                        style="font-size: 20px; color: #082FB1; cursor: pointer;"
                                    ></span>
                                </template>
                            </v-tooltip>
                        </v-col>
                    </div>
                </v-col>  -->

                <!-- <v-col cols="12">
                    <div class="warehouse-container" v-if="selectedName">
                        <table style="width: 100%;" class="core_tabel">
                            <tbody>
                                <template v-for="(users,index) in selectedWareHouse" :key="index">
                                    <tr v-if="users.deleted === 0">
                                        <td style="border-top-left-radius:4px ;border-bottom-left-radius:4px;">
                                            <div class="d-flex align-center justify-center"
                                                style="width: 32px;height: 32px;border-radius: 50%;background-color: #1542F5; color: #ffff;">
                                                {{ `${users.first_name.charAt(0) || ""}${users.last_name.charAt(0) || ""}` }}
                                            </div>
                                        </td>
                                        <td style="font-size: 14px;font-weight: 600;">{{ `${users.first_name} ${users.last_name}` }}</td>
                                        <td style="text-decoration: underline;font-size: 12px;font-weight: 400;">{{ users.email }}</td>
                                        <td style="font-size: 14px;font-weight: 400;">{{ `${role < 6 ? users?.mobile ?? '' :'**********'}` }}</td>
                                        <td style="font-size: 14px;font-weight: 500;">
                                            <div class="d-flex ga-2 align-center">
                                                <div :style="{width: '14px',height: '14px',backgroundColor : users.status === 'Active' ? '#0DB768' : '#FF3B30'}"></div>{{ users.status }}
                                            </div>
                                        </td>
                                        <td class="mod">
                                            <v-tooltip :text="users.modified_name" location="top">
                                                <template #activator="{ props }">
                                                <span
                                                    v-bind="props"
                                                    class="ma-1 py-1 px-1 chip"
                                                >
                                                    {{ `${getTrimmedText(users?.modified_name) ?? '--'}, ${users?.modified ? moment(users.modified).format('DD-MM-YYYY') : '--'}`}}
                                                </span>
                                                </template>
                                            </v-tooltip>
                                        </td>
                                        <td style="border-top-right-radius:4px ;border-bottom-right-radius:4px">
                                            <v-menu location="bottom" v-if="role < 6">
                                                <template #activator="{ props }">
                                                    <v-btn v-bind="props" icon variant="text" class="cursor-pointer">
                                                        <v-icon>mdi-dots-vertical</v-icon>
                                                    </v-btn>
                                                </template>

                                                <v-list density="compact">
                                                    <v-list-item @click="editLocation(value, index, value.warehouse_name, WHindex)">
                                                        <v-list-item-title>Edit</v-list-item-title>
                                                    </v-list-item>
                                                    <v-list-item @click="deleteWarehouseUser(WHindex, value, index)">
                                                        <v-list-item-title>Delete</v-list-item-title>
                                                    </v-list-item>
                                                </v-list>
                                            </v-menu>
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </v-col> -->
            <!-- </v-row> -->
        <!-- </template> -->
        <!-- contacts table -->
        <v-row>
            <div class="pa-2 table-container" style="height: 100%; width: 100%; overflow-x: auto;">
                <CommonTable @dialogs="editWareHouse" :selectedName="selectedName" :title="'Contact'" @add="addContact" :role="role" :headers="headers" @enum="addEnum" :dataList="isFiltered? filteredContacts:contacts" />
            </div>
        </v-row>
    </v-card>
    
<!-- contact form -->
    <v-dialog  v-model="warehouseDialog" width="550">
        <WarehouseForm 
            @close="close" 
            @save="save" 
            :viewType="viewType" 
            :designation="designation" 
            :index="index" 
            @update-warehouse="updateWarehouse" 
            :editLocationData="editLocationData" 
            :users="addUsers" 
            :WHindex="WHindex"
        />
    </v-dialog>

<!-- enums form -->
    <v-dialog v-model="enumDialog" width="550">
        <TypeDialog 
            :viewType="viewType" 
            :designation="designation" 
            :users="addUsers" 
            :data = 'data'
            @update-warehouse="updateWarehouse" 
            :editLocationData="editLocationData" 
            @close="close1" 
        />
    </v-dialog>

    <!-- <v-dialog v-if="ediDialog" v-model="ediDialog" width="700" min-height="250">
        <v-card variant="flat" class="px-4 pt-3" style="border-radius: 16px;">
            <v-col cols="12" class="edi d-flex  align-center">
                <h2 class="card_title">EDI Transcations</h2>
                <span @click="closeEdi" class="mdi mdi-close" style="font-size: 25px;"></span>
            </v-col>
            <v-col cols="12" class="d-flex">
                <v-chip v-for="(chip, index) in ediData.edi" :key="index" color="primary" class="ma-1">
                    {{ chip }}
                </v-chip>
            </v-col>
        </v-card>
    </v-dialog> -->

    <v-snackbar
        v-model="showSnackbar"
        timeout="2000"
        color="#D4EDDA"
        location="top"
    >
      Copied!
    </v-snackbar>
</template>

<script>

import clientDetailsService from '@/api/service/ClientDetails/ClientDetailsService';
import WarehouseForm from './warehouseForm.vue';
import AutoComplete from '@/components/ui/AutoComplete.vue';
import moment from 'moment';
import CommonTable from '@/menus/CommonTable.vue';
import TypeDialog from './TypeDialog.vue';
export default {
    components: {
        WarehouseForm,
        AutoComplete,
        CommonTable,
        TypeDialog
    },
    data: () => ({
         headers:[
          {title:"First Name",value:'first_name',minWidth:'250px'},
          {title:"Last Name",value:'last_name',minWidth:'250px'},
          {title:"Email",value:'email',minWidth:'300px'},
        //   {title:"WareHouse",value:'contactAccess',minWidth:'250px'},
          {title:"Mobile Number",value:'mobile',minWidth:'200px'},
          {title:"Status",value:'status',minWidth:'150px'},
          { title: "Actions", value: 'actions', minWidth: '150px',}, 
        ],
        warehouseDialog: false,
        enumDialog:false,
        ediDialog:false,
        ediData:{},
        organisationData: {},
        filteredContacts: [],
        isFiltered:false,
        warehouse: [],
        contacts:[],
        designation: null,
        addUsers:false,
        processLead: [],
        viewType:null,
        editLocationData:{},
        index: null,
        WHindex:null,
        processAssociate: [],
        showSnackbar:false,
        user_id:null,
        user_name:null,
        role:null,
        data:null,
        selectedWareHouse:[],
        selectedName:null,
    }),
    created() {
        this.getOrganisation();
        let user = JSON.parse(localStorage.getItem('user_details'))
        this.user_id = user.id
        this.role = user.roles.role_type
        this.user_name = user.username
    },
    methods: {
        moment,
        reloadPage() {
            window.location.reload();
        },
        addEnum(data){
            console.log(data,"eeeee222")
            this.designation="enum"
            this.viewType="edit"
            this.data = data
            this.enumDialog = true
        },
        addContact(value){
            console.log(value,"addWarehouse")
            this.designation="Contact"
            this.viewType="add"
            this.warehouseDialog = true
        },
        onSelectWarehouse($value) {
                console.log($value,"$value!!!")
            if (!$value || !$value.warehouse_name) return;
            
            const matchedContacts = this.contacts.filter(contact => {
                return contact.contactAccess?.some(access =>
                    access.wareHouse?.some(wh => wh.warehouse_name === $value.warehouse_name)
                );
            });

            if (matchedContacts.length > 0) {
                this.selectedName = $value.warehouse_name;
                console.log(typeof this.selectedName,"this.selectedNameiiiiiii")
                this.selectedWareHouse = matchedContacts;
            }
            let contactData = this.contacts
            console.log(this.contacts,"1244jhh")
            this.filteredContacts = contactData.filter(item => {
                return item?.contactAccess?.[0]?.wareHouse?.some(wh => wh.warehouse_code === $value.warehouse_code)
            })
            if(this.filteredContacts.length > 0){
                this.isFiltered = true
            }
            console.log(this.contacts,"this.contacts &&&&&&")
        },
       
        editWareHouse(value,WHindex,viewType,index){
            // alert(viewType)
            console.log(value, WHindex, viewType,"editWareHouse")
            this.editLocationData = value;
            this.designation="Contact"
            this.index = index;
            this.WHindex = WHindex
            this.warehouseDialog = true;
            this.viewType=viewType
        },
        ediChips(value){
            console.log(value,"ttttttttttttt")
            this.ediData = value
            this.ediDialog = true
        },
        getTrimmedText(text) {
          return text && text.length <= 12 ? text : text && text.slice(0, 12) + ' ...';
        },
        async getOrganisation() {
            let $id = this.$route.query.id
            this.organisationData = await clientDetailsService.findOne({ id: $id, collectionName: 'organisation' })
            console.log(this.organisationData, 'dataaaaaaaaaaaa')
            this.contacts = this.organisationData && this.organisationData.contacts ? this.organisationData.contacts : []
            this.warehouse = this.organisationData && this.organisationData.wareHouse ? this.organisationData.wareHouse : []
            // this.contacts = this.organisationData && this.organisationData.warehouse_details && this.organisationData.warehouse_details[0].warehouse_name ? this.organisationData.warehouse_details : []
            // this.processLead = this.organisationData && this.organisationData.teams && this.organisationData.teams.process_lead ? this.organisationData.teams.process_lead : []
            // this.processAssociate = this.organisationData && this.organisationData.teams && this.organisationData.teams.process_associate ? this.organisationData.teams.process_associate : []
            console.log(this.contacts,"this.contacts")
        },
        closeEdi(){
            this.ediDialog = false
        },
        close() {
            this.warehouseDialog = false
        },
        close1(){
            this.enumDialog = false
        },
        // editLocation(item, index,$data,WHindex) {
        //     this.editLocationData = item;
        //     // this.designation = $data
        //     this.warehouseDialog = true;
        //     // this.index = index;
        //     // this.WHindex = WHindex
        //     this.viewType="edit"
        //     console.log(this.editLocationData,"dddd",this.designation,"dddd",this.index,"dddd",WHindex);
        // },
        save(item, designation) {
            // alert('save')
            let now = moment().format('YYYY-MM-DD HH:mm:ss')
            console.log(item, "item!!!", designation)
            // if (designation === 'Warehouse') {
                let obj = {}                    
                    // obj.warehouse_name = item.warehouse_name,
                    // obj.edi = item.edi,
                    // obj.users = []
                    obj.id = this.contacts.length + 1,
                    // obj.users.push({
                    obj.first_name = item.first_name,
                    obj.last_name = item.last_name,
                    obj.mobile = item.mobile,
                    obj.status = item.status,
                    obj.email = item.email,
                    obj.created = now,
                    obj.modified = null,
                    obj.created_by = this.user_id,  
                    obj.modified_by = null,
                    obj.active = item.status == 'Active'? 1: 0,
                    obj.deleted = item.status != 'Active'? 1: 0,
                    obj.deleted_by = null,
                    // })     
                    // obj.created = now,
                    // obj.modified = null,
                    // obj.created_by = this.user_id,  
                    // obj.modified_by = null,
                    // obj.active = 1,
                    // obj.deleted = 0,
                    // obj.deleted_by = null,           
                this.contacts.push(obj)
                console.log(this.contacts,"this.contact")
            // } 
            this.saveAllData()
        },
        updateWarehouse(data,whIndex,index,type){
            // alert(1)
            console.log(data,whIndex,index,type,"dddd");
            let now = moment().format('YYYY-MM-DD HH:mm:ss')
            if(type == 'edit'){
                // alert(2)
                data.modified = now
                data.modified_by = this.user_id 
                data.modified_name = this.user_name
                data.active = data.status == 'Active'? 1: 0,
                data.deleted = 0,
                data.deleted_by = null
                // delete data.status
                this.contacts[index] = data
                console.log(this.contacts,"77777")
                this.saveAllData()
            }
            else{
                // alert(3)
                data.id = this.contacts.length + 1
                data.created = now
                data.modified = null
                data.created_by = this.user_id 
                data.modified_name = this.user_name 
                data.modified_by = null
                data.active = data.status == 'Active'? 1: 0,
                data.deleted = 0,
                data.deleted_by = null
                // delete data.status
                this.contacts.push(data)
                this.saveAllData()
                console.log(this.contacts,'after add')
            }
        },
        async saveAllData() {
            // alert('save all')
            this.organisationData.contacts = this.contacts
            let $data = {
                collectionName: 'organisation',
                data: this.organisationData,
                id: this.$route.query.id
            }
            await clientDetailsService.update($data)
            // window.location.reload()
        },
        formDialog(designation,index) {
            this.WHindex = index
            console.log(this.WHindex,"rtrtr");
            this.designation = designation
            this.warehouseDialog = true
            if(designation != "Warehouse" ){
                this.addUsers = true
            }
            else{
                this.addUsers = false
            }
            this.viewType="add"
        },

        deleteWarehouseUser(WHindex,value,index) {
            let now = moment().format('YYYY-MM-DD HH:mm:ss')
            //this.warehouse[WHindex].users.splice(index, 1);
            this.warehouse[WHindex].users[index].status = 'Inactive'
            this.warehouse[WHindex].users[index].modified = now
            this.warehouse[WHindex].users[index].modified_by = this.user_id,
            this.warehouse[WHindex].users[index].active = 0
            this.warehouse[WHindex].users[index].deleted = 1
            this.warehouse[WHindex].users[index].deleted_by = this.user_id
            this.saveAllData()
        },

        copyAllEmails(users) {
            const emails = users
            .filter(u => u.status === 'Active')  
            .map(u => u.email)                    
            .join(', ');                          
            navigator.clipboard.writeText(emails).then(() => {
                this.showSnackbar=true
            // this.$toast?.success?.('All emails copied!') || alert('All emails copied!');
            });
        },
    }
}
</script>
<style scoped>
.edi{
    justify-content: space-between;
}
.modifydate{
  display: flex;
  justify-content: end;
}
.mod{
  font-size: 12px;
  font-weight: 500;
  text-align: end;
}
.chip{
  font-size: 12px;
  font-weight: 600;
  color: crimson;
}
.warehouse-container{
    /* border: 1.5px solid #cfcfcf; */
    padding: 8px 16px ;
    /* min-height: 190px; */
    max-height: 270px;
    border-radius: 8px;
    overflow-y: auto !important;
    box-shadow: 
    0 2px 6px rgba(0, 0, 0, 0.2), /* soft shadow */
    0 2px 6px rgba(0, 0, 0, 0.3); /* stronger shadow */
    /* box-shadow: 0 18px 18px rgba(0, 0, 0, 0.1); */
}
.warehouse-container:hover {
  box-shadow: 
    0 6px 12px rgba(0, 0, 0, 0.2), /* soft shadow */
    0 10px 20px rgba(0, 0, 0, 0.3); /* stronger shadow */
}
.core_card {
    background-color: #FEFEFE;
    padding: 20px;
}

.card_title {
    font-size: 20px;
    font-weight: 600;
}

.sub_title {
    font-size: 16px;
    font-weight: 700;
}

.core_tabel {
    border-collapse: separate;
    border-spacing: 0 10px;
}

.core_tabel tbody tr {
    border-radius: 8px;
    overflow: hidden;
    display: table-row;
}

.core_tabel tbody tr td {
    padding: 12px 26px !important;
    background-color: #F2F2F2;
}
</style>